import { createSlice } from "@reduxjs/toolkit";
import {
  addCoupon,
  cloneCoupon,
  deleteCoupon,
  getAllCoupons,
  getcashbacklist,
  getCouponDetails,
  getRewardSettingList,
  getRewardsList,
  updateCoupon,
  updateCouponStatus,
  updateRewardsScreen,
} from "store/actions/couponAction";
import { updatecashback } from "store/actions/workspaceSlice";

const initialState = {
  isLoading: false,
  loading: false,
  perPage: 50,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  coupons: [],
  couponDetails: {},
  rewardsList: [],
  cashbackList: [],
  rewardSettingList: [],
};

const couponSlice = createSlice({
  name: "coupon",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllCoupons.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllCoupons.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } =
            action.payload || {};
          state.coupons = data;

          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getAllCoupons.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(updateCouponStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateCouponStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success } = action.payload || {};
        if (success) {
          const { id, status } = action.meta.arg;
          state.coupons = state?.coupons?.map((item) =>
            item._id === id ? { ...item, status: status } : item
          );
        }
      })
      .addCase(updateCouponStatus.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(deleteCoupon.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteCoupon.fulfilled, (state, action) => {
        const { success } = action.payload || {};
        const { id } = action.meta.arg;
        state.isLoading = false;
        if (success) {
          state.coupons = state.coupons.filter((item) => item._id !== id);
          if (state.totalCount !== null) {
            state.totalCount -= 1;
          }
        }
      })
      .addCase(deleteCoupon.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(cloneCoupon.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(cloneCoupon.fulfilled, (state, action) => {
        const { success, data } = action.payload || {};
        state.isLoading = false;
        if (success) {
          state.coupons = [...state.coupons, data];
        }
      })
      .addCase(cloneCoupon.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getCouponDetails.pending, (state) => {
        state.loading = true;
        state.couponDetails = {};
      })
      .addCase(getCouponDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.couponDetails = data;
        }
      })
      .addCase(getCouponDetails.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(addCoupon.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addCoupon.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(addCoupon.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateCoupon.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateCoupon.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateCoupon.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getRewardsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRewardsList.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.rewardsList = data[0] || {};
        }
      })
      .addCase(getRewardsList.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(updateRewardsScreen.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateRewardsScreen.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateRewardsScreen.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updatecashback.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatecashback.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updatecashback.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getcashbacklist.pending, (state) => {
        state.loading = true;
      })
      .addCase(getcashbacklist.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.cashbackList = data || [];
        }
      })
      .addCase(getcashbacklist.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getRewardSettingList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRewardSettingList.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.rewardSettingList = data || [];
        }
      })
      .addCase(getRewardSettingList.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default couponSlice.reducer;
